document.addEventListener('alpine:init', function () {
    Alpine.data('showroomLocations', function () {
        return {
            openIDs: [],
            toggle: function (id, title) {
                if (this.isOpen(id)) {
                    this.close(id);
                }
                else {
                    this.open(id, title);
                }
            },
            isOpen: function (id) {
                return this.openIDs.includes(id);
            },
            open: function (id, title) {
                this.openIDs.push(id);
                this.$store.app.track({
                    event: 'click_accordions',
                    type: 'click',
                    trigger: 'expand',
                    module: 'showroom-locations',
                    data: {
                        title: title,
                    },
                });
            },
            close: function (id) {
                this.openIDs = this.openIDs.filter(function (i) { return i !== id; });
            },
        };
    });
});
